import { AnimatePresence, motion } from "framer-motion";

import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";
import { deleteMotion } from "UI/motionStyles";

import {
  useAddOnGifts,
  useDeletedAddOnGifts,
  useHasAddOnGifts,
} from "../stateHooks";

import Editor from "./Editor";

const AddOnGiftsSection = () => {
  const [addOnGifts = {}] = useAddOnGifts();
  const [, addDeletedAddOnGift] = useDeletedAddOnGifts();
  const hasAddOnGifts = useHasAddOnGifts();

  if (!hasAddOnGifts) return null;

  return (
    <FnrVerticalGap gap={4} data-cy="AddOnGiftsSection_Container">
      <AnimatePresence>
        {Object.entries(addOnGifts).map(([addOnGiftID, addOnGift]) => {
          const handleDelete = () => addDeletedAddOnGift(addOnGiftID);

          return (
            <motion.div key={addOnGiftID} {...deleteMotion}>
              <Editor
                deleteGift={handleDelete}
                addOnGiftID={addOnGiftID}
                {...addOnGift}
              />
            </motion.div>
          );
        })}
      </AnimatePresence>
    </FnrVerticalGap>
  );
};

export default AddOnGiftsSection;
